var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"appbg"},[_c('AppHeader'),_c('v-layout',[_c('v-flex',{attrs:{"pt-12":""}},[_c('router-view')],1)],1),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }